import axios from "axios";
import { Constants } from "utils";

/**
 * responsible for creating the instance of axios to connect to Github API
 */

export const current = () => axios.create({
  baseURL: Constants.API_BASE_URL,
  "headers": {
    "ngrok-skip-browser-warning": "1"
  }
});

/**
 * responsible for checking if the API is working
 */

export const currentHealthCheck = async () => await current().get("/health-check");